// extracted by mini-css-extract-plugin
export var container = "_4t-0";
export var fallback = "_4t-5";
export var fallbackIcon = "_4t-6";
export var hidden = "_4t-2";
export var image = "_4t-3";
export var loaded = "_4t-4";
export var placeholder = "_4t-1";